import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash'
import { FormattedMessage, useIntl } from 'react-intl';

import 'draft-js/dist/Draft.css';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';

import {
  HelpOutlineIcon,
  CheckBoxOutlineBlankIcon,
  CheckBoxIcon,
  HighlightOffOutlinedIcon,
  KeyboardArrowDownOutlinedIcon,
  CorporateFareIcon,
} from '../../../constants/images';

import theme from '../../../theme';

import { CustomFormLabel } from '../../customComponent';

import { MODAL_CREATE_REPORT } from '../../modal/constants';

import { apiList } from '../../../api/callAPI';

import useUser from '../../../hook/useUser';
import useGlobalStatus from '../../../hook/useGlobalStatus';
import useColorSystem from '../../../hook/useColorSystem';

import * as urlConstants from '../../../constants/url';
import * as alertConstants from '../../../constants/alertMsg';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const GoogleCampaignData = (props) => {
  const {
    media,
    selectedAdAccounts,
    campaignList,
    setCampaignList,
    selectedCampaign,
    setSelectedCampaign,
    setIsLoading,
  } = props;

  const history = useHistory();
  const intl = useIntl();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { currentActiveData, setCurrentActiveData, locale, setLocale, entryPath, setEntryPath, setModalContent, setIsModalOpen } = useGlobalStatus();
  const [allCampaignChecked, setAllCampaignChecked] = useState(false);
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  //取得廣告活動
  const getSelectedCampaign = (allCampaign, selectedCampaign) => {
    return _.filter(allCampaign, el => _.findIndex(selectedCampaign, c => c === el.id) > -1);
  }

  useEffect(() => {
    if (entryPath.includes('edit') && selectedAdAccounts.length > 0) {
      setIsLoading(true);
      fetchCampaignData();
    }
  }, [selectedAdAccounts])

  //選擇全部廣告活動
  useEffect(() => {
    if (campaignList.length !== 0 && selectedCampaign.length === campaignList.length) {
      setAllCampaignChecked(true);
    } else {
      setAllCampaignChecked(false);
    }
  }, [selectedCampaign])

  //匯入廣告活動
  const handleGetCampaign = () => {
    if (!selectedAdAccounts.length) return;
    fetchCampaignData();
  }

  //選擇全部廣告活動
  const changeAllCampaign = (e) => {
    const { checked } = e.target;
    if (checked === true) {
      setAllCampaignChecked(true);
      setSelectedCampaign(campaignList);
    } else {
      setAllCampaignChecked(false);
      setSelectedCampaign([]);
    }
  }

  //匯入廣告活動
  const fetchCampaignData = () => {
    setIsLoading(true);
    setSelectedCampaign([]);
    const adAccountId = selectedAdAccounts.map(el => el.adAccountId);

    if (!adAccountId.length) return;

    apiList.googleGetCampaign({
      cid: adAccountId.toString()
    })
      .then(res => {
        if (res.status === 200) {
          const resultData = res.data.result;

          if (entryPath === urlConstants.PAGE_GOOGLE_CREATE_DATA) {
            if (resultData === null || !resultData.length) {
              setModalContent({ ...MODAL_CREATE_REPORT['checkNoCampaign'], media: media });
              setCampaignList([]);
            } else {
              setModalContent({ ...MODAL_CREATE_REPORT['checkImportCampaign'], media: media });
              setCampaignList(resultData);
            }
            setIsModalOpen(true);

          } else if (entryPath === urlConstants.PAGE_GOOGLE_EDIT_DATA) {
            if (resultData === null || !resultData.length) {
              setCampaignList([]);
            } else {
              setCampaignList(resultData);
              setSelectedCampaign(getSelectedCampaign(resultData, currentActiveData.campaignList))
            }
          }

          setIsLoading(false);

        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          alert(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }

  return (
    <Box mb={5}>
      <Box
        mt={2}
        sx={{ width: '100%' }}
      >
        <Stack variant='between-center'>
          <CustomFormLabel>
            <FormattedMessage id="createData.campaign.campaign" values={{ campaign: "廣告活動" }} />
            <Tooltip title={<FormattedMessage id="createData.campaign.tip" />}>
              <HelpOutlineIcon variant="dark" />
            </Tooltip>
          </CustomFormLabel>
          {selectedAdAccounts.length > 0 && entryPath.includes('create') &&
            <Typography
              sx={{
                cursor: 'pointer',
                p: 0,
                marginBottom: '8px',
                color: mainColor
              }}
              onClick={() => handleGetCampaign()}
            >
              <FormattedMessage id="createData.campaign.import" values={{ campaign: "廣告活動" }} />
            </Typography>
          }
        </Stack>

        <Autocomplete
          multiple
          size="small"
          id="selectCampaign"
          options={campaignList}
          groupBy={(option) => option.cidname}
          disableCloseOnSelect={campaignList.length > 1 ? true : false}
          disableClearable={true}
          noOptionsText={<FormattedMessage id="createData.campaign.noOptionsText" values={{ campaign: "廣告活動" }} />}
          value={selectedCampaign}
          getOptionLabel={(option) => option.name}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                color={colorMedia}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              color={colorMedia}
              placeholder={intl.formatMessage(
                { id: "createData.campaign.placeholder" },
                { campaign: "廣告活動" }
              )}
            />
          )}
          onChange={(event, newValue) => {
            setSelectedCampaign(newValue);
          }}
          ChipProps={{
            deleteIcon: <HighlightOffOutlinedIcon />
          }}
          popupIcon={<KeyboardArrowDownOutlinedIcon />}
        />
        {<CustomFormLabel
          sx={{
            display: 'inline-block',
            mt: '2px',
            cursor: 'pointer',
          }}
          onClick={() => {
            setSelectedCampaign(campaignList)
          }}
        >
          <Checkbox
            size="small"
            name="allCampaign"
            color={colorMedia}
            checked={allCampaignChecked}
            onChange={changeAllCampaign}
            disabled={campaignList.length > 0 ? false : true}
          />
          <FormattedMessage id="createData.campaign.allCampaign" values={{ campaign: "廣告活動" }} />
        </CustomFormLabel>
        }
      </Box>
    </Box>
  )
}

export default GoogleCampaignData;